
















import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import SalesTabsManagement from "@/pages/Sales/SalesTabs/SalesTabsManagement.vue";
import { SelectMarket } from "@/interfaces/global-data";
import MarketSelect from '@/components/MarketSelect.vue';

@Component({
    components: {
        MarketSelect,
        SalesTabsManagement,
    },
})

export default class SalesManagement extends Mixins(LocalData) {
    @Prop({ default: null }) readonly activeTabKeyProp?: string | null;

    private isRenderSalesTabs: boolean = true;

    updateSelectMarket(market: SelectMarket) {
        if (this.$sales.selectMarket.id !== market.id) {
            this.$sales.selectMarket = market;

            this.$sales.individualSaleConfig = {};

            localStorage.setItem('sales', JSON.stringify(this.$sales));

            this.isRenderSalesTabs = false;

            this.$nextTick(() => {
                this.isRenderSalesTabs = true;
            })
        }
    }
}
